export interface DeletableAndEditableCC {
  id: Word.ContentControl["id"];
  cannotDelete: Word.ContentControl["cannotDelete"];
  cannotEdit: Word.ContentControl["cannotEdit"];
}

async function getCCRange(context: Word.RequestContext, ccId: number) {
  const contentControl: Word.ContentControl = context.document.contentControls.getById(ccId);
  await context.sync();
  const range = contentControl.getRange("Whole");
  await context.sync();

  return range;
}

export async function getXMLFromSelection() {
  try {
    return await Word.run(async (context) => {
      const range = context.document.getSelection();
      range.load(["items"]);
      context.load(range);
      await context.sync();

      const ooxmlRange = range.getOoxml();
      await context.sync();
      // eslint-disable-next-line office-addins/load-object-before-read
      return ooxmlRange.value;
    });
  } catch (error) {
    console.error(error);
    return "";
  }
}

export async function getXmlByCCId(ccId: number) {
  try {
    return await Word.run(async (context) => {
      const range = await getCCRange(context, ccId);

      const ooxmlRange = range.getOoxml();
      await context.sync();
      // eslint-disable-next-line office-addins/load-object-before-read
      return ooxmlRange.value;
    });
  } catch (error) {
    console.error(error);
    return "";
  }
}

export async function insertXmlIntoSelection(context: Word.RequestContext, xmlString: string) {
  const range = context.document.getSelection();
  range.insertText("", Word.InsertLocation.replace);
  await context.sync();
  const newRange = range.insertOoxml(xmlString, Word.InsertLocation.replace);
  await context.sync();
  return newRange;
}

export async function deleteRangeSelection() {
  return await Word.run(async (context) => {
    try {
      const range = context.document.getSelection();
      range.load(["items"]);
      context.load(range);
      await context.sync();
      range.delete();
      await context.sync();
    } catch (e) {
      console.error("=>(WordXMLManager.ts:67) error:", e);
    }
  });
}

export async function deleteRangeCC(ccId: number) {
  return await Word.run(async (context) => {
    try {
      const range = await getCCRange(context, ccId);
      range.delete();
      await context.sync();
    } catch (error) {
      console.error(error);
    }
  });
}

export async function toggleDeleteAndEditCC(cc: Omit<DeletableAndEditableCC, "title">) {
  return Word.run(async (context) => {
    try {
      const contentControl: Word.ContentControl = context.document.contentControls.getById(cc.id);
      contentControl.cannotDelete = cc.cannotDelete;
      contentControl.cannotEdit = cc.cannotEdit;
      await context.sync();
    } catch (error) {
      console.log(`Error toggleDeleteAndEditCC`, error);
    }
  });
}
